import { BadgeCheck } from "lucide-react";
import { Chapter, FadeUp } from "./Reveal";
import { YOUTUBE_EMBED, CREATOR_RESULTS } from "../../data/content";

const ResultCard = ({ name, tag, img, stat, caption, testId }) => (
    <div className="rounded-lg border border-slate-200 bg-white p-7 md:p-8" data-testid={testId}>
        <div className="flex items-center gap-4">
            <img
                src={img}
                alt={`${name}, ${tag}`}
                className="w-16 h-16 rounded-full object-cover border-2 border-accent/30 bg-white"
                loading="lazy"
            />
            <div>
                <p className="text-base font-semibold text-navy">{name}</p>
                <p className="text-xs uppercase tracking-[0.2em] text-slate-400 mt-0.5">{tag}</p>
            </div>
        </div>
        <div className="mt-6 flex items-baseline gap-3">
            <span className="font-display font-bold tracking-tight text-4xl md:text-5xl text-navy">{stat}</span>
        </div>
        <p className="mt-2 text-sm md:text-base text-slate-600">{caption}</p>
    </div>
);

const Proof = () => (
    <section id="proof" className="bg-white py-24 md:py-32" data-testid="proof-section">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
            <Chapter
                index="03"
                label="Impact"
                title={["Receipts,", "not promises."]}
            />

            <div className="grid lg:grid-cols-5 gap-6 md:gap-8">
                <FadeUp className="lg:col-span-3">
                    <div className="rounded-lg overflow-hidden border border-slate-200 shadow-[0_30px_60px_-30px_rgba(31,42,68,0.2)]" data-testid="proof-video-embed">
                        <div className="aspect-video">
                            <iframe
                                src={YOUTUBE_EMBED}
                                title="Client testimonial | ChatProz"
                                className="w-full h-full"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                loading="lazy"
                            />
                        </div>
                    </div>
                    <p className="mt-4 text-xs uppercase tracking-[0.25em] text-slate-400">
                        Watch: client testimonial
                    </p>
                </FadeUp>

                <div className="lg:col-span-2 flex flex-col gap-6">
                    <FadeUp delay={0.1} className="h-full">
                        <div className="h-full rounded-lg border border-slate-200 bg-white p-7 md:p-8 flex flex-col justify-center" data-testid="proof-authority-card">
                            <BadgeCheck className="w-6 h-6 text-accent mb-4" />
                            <p className="text-base md:text-lg leading-relaxed text-navy">
                                Led by a founder with <span className="font-semibold">more than a decade of expertise</span> in
                                marketing, branding & business, government-recognized by the DC Ludhiana.
                            </p>
                            <p className="mt-5 text-sm font-semibold text-navy">Kuunal Pruuthi</p>
                            <p className="text-xs uppercase tracking-[0.2em] text-slate-400 mt-1">Founder, ChatProz</p>
                        </div>
                    </FadeUp>
                </div>
            </div>

            <div className="mt-16 md:mt-20" data-testid="creator-results-wall">
                <FadeUp>
                    <p className="text-xs font-semibold uppercase tracking-[0.3em] text-slate-400 mb-8">
                        Creator & brand growth, in real numbers
                    </p>
                </FadeUp>
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                    {CREATOR_RESULTS.map((r, i) => (
                        <FadeUp key={r.name} delay={i * 0.12}>
                            <ResultCard
                                {...r}
                                testId={`proof-result-${r.name.toLowerCase().replace(/\s+/g, "-")}`}
                            />
                        </FadeUp>
                    ))}
                </div>
            </div>
        </div>
    </section>
);

export default Proof;
